import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "";

export interface AddPortPayload {
	hardwareResourceId: number; //This comes from Hardware ep
	portName: string;
	portNumber: string;
	portType: string;
	portStatus: string;
	l2Description: string;
	l3Description: string;
	id?: number;
	portId?: string;
}
export interface UpdateFwaasPayload {
	name?: string;
	subscriptionId?: string;
	terms?: number | null;
	autoRenew?: boolean | null;
	connections?: string;
	hostConfigs?: Array<{ host: string; pve_host: string }>;
}
export interface CreateFwaasPayload {
	tenantId: number;
	name: string;
	subscriptionId: string;
	terms: number;
	autoRenew: boolean;
	connections: string;
}

//GET v1/resource-manager/ke-fwaas
export function getListFwaas(token: string) {
	return axios.get(`${API_URL}/v1/resource-manager/ke-fwaas`, {
		headers: {
			Authorization: `Bearer ${token}`,
			"Content-Type": "application/json",
		},
	});
}

//GET v1/resource-manager/ke-fwaas/:id
export function getFwaasById(token: string, id: string | number) {
	return axios.get(`${API_URL}/v1/resource-manager/ke-fwaas/${id}`, {
		headers: {
			Authorization: `Bearer ${token}`,
			"Content-Type": "application/json",
		},
	});
}

//PUT v1/resource-manager/ke-fwaas/:id
export function updateFwaasById(token: string, id: string | number, payload: UpdateFwaasPayload) {
	return axios.put(`${API_URL}/v1/resource-manager/ke-fwaas/${id}`, payload, {
		headers: {
			Authorization: `Bearer ${token}`,
			"Content-Type": "application/json",
		},
	});
}

//DELETE v1/resource-manager/ke-fwaas/:id
export function deleteFwaasById(token: string, id: string | number) {
	return axios.delete(`${API_URL}/v1/resource-manager/ke-fwaas/${id}`, {
		headers: {
			Authorization: `Bearer ${token}`,
			"Content-Type": "application/json",
		},
	});
}

//CREATE v1/resource-manager/ke-fwaas
export function createFwaas(token: string, payload: CreateFwaasPayload) {
	return axios.post(`${API_URL}/v1/resource-manager/ke-fwaas`, payload, {
		headers: {
			Authorization: `Bearer ${token}`,
			"Content-Type": "application/json",
		},
	});
}
